import React from 'react';
// @ts-ignore
const WMLoaderLazy = React.lazy(() => import(/* webpackPrefetch: true */ '@walkme/ui-core/packages/core/src/Loader/Loader.esm').then((module) => ({ default: module.Loader })));

export const WMLoader = (props: any) => {
    return (
        <React.Suspense fallback={null}>
            <WMLoaderLazy size="large" {...props} />
        </React.Suspense>
    );
};
